import type { FC } from 'react';
import { ID_TOC_CONTAINER } from 'src/hooks/page/use-dnd/helper';

import { TocItem } from '../toc/toc-item';
import { useShareAsideRootId } from './share-aside-context';

export const ShareToc: FC = () => {
  const rootId = useShareAsideRootId();
  if (!rootId) return null;
  return (
    <div id={ID_TOC_CONTAINER} className="mt-2.5 overflow-auto">
      <TocItem uuid={rootId} deep={0} />
    </div>
  );
};
